import { api, apiUrl, callAPi } from "./api";

const loginUser = (data) => api.post("/admin/login", data);
const generateOtp = (data) => callAPi.post("/generate_otp", data);
const getUser = () => callAPi.get("/user");

const forgetPassword = (data) => callAPi.post("/forget-password", data);
const verifyOtp = (data) => callAPi.post("/verify-forget-otp", data);
const resendOtp = (data) => callAPi.post("/resend-forget-otp", data);
const resetPassword = (data) => callAPi.post("/reset-password", data);

const register = (data) => callAPi.post("/register", data);

const authServices = {
  resendOtp,
  loginUser,
  forgetPassword,
  generateOtp,
  verifyOtp,
  getUser,
  resetPassword,
  register,
};

export default authServices;
